/**
 * @flow
 * @relayHash c1c35dd00294c3f4b9cbec31204f4601
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedBomsContainer_boms$ref = any;
export type ItemSortField = "BOM_NUMBER" | "CREATED_AT" | "ITEM_NUMBER" | "NAME" | "PART_NUMBER" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type ItemSort = {|
  field: ItemSortField,
  direction: SortDirection,
|};
export type BomInquiryQueryVariables = {|
  count: number,
  search?: ?string,
  cursor?: ?string,
  sortBy?: ?ItemSort,
|};
export type BomInquiryQueryResponse = {|
  +$fragmentRefs: PaginatedBomsContainer_boms$ref
|};
export type BomInquiryQuery = {|
  variables: BomInquiryQueryVariables,
  response: BomInquiryQueryResponse,
|};
*/


/*
query BomInquiryQuery(
  $search: String
  $sortBy: ItemSort
) {
  ...PaginatedBomsContainer_boms_3FyenR
}

fragment PaginatedBomsContainer_boms_3FyenR on Query {
  items(first: 30, search: $search, sortBy: $sortBy, hasBom: true) {
    edges {
      cursor
      ...BomsTable_itemEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment BomsTable_itemEdges on ItemEdge {
  node {
    id
    bomNumber
    itemNumber
    partNumber
    name
    description
    bomComponentCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemSort",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v2 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "hasBom",
    "value": true
  },
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BomInquiryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedBomsContainer_boms",
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BomInquiryQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "ItemConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomComponentCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "items",
        "args": (v3/*: any*/),
        "handle": "connection",
        "key": "PaginatedBomsContainer_items",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BomInquiryQuery",
    "id": null,
    "text": "query BomInquiryQuery(\n  $search: String\n  $sortBy: ItemSort\n) {\n  ...PaginatedBomsContainer_boms_3FyenR\n}\n\nfragment PaginatedBomsContainer_boms_3FyenR on Query {\n  items(first: 30, search: $search, sortBy: $sortBy, hasBom: true) {\n    edges {\n      cursor\n      ...BomsTable_itemEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BomsTable_itemEdges on ItemEdge {\n  node {\n    id\n    bomNumber\n    itemNumber\n    partNumber\n    name\n    description\n    bomComponentCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'df46796e71ddf5b3fc0f995d550382b6';
module.exports = node;
